import { render, staticRenderFns } from "./ContactoComponent.vue?vue&type=template&id=29aceedc&"
import script from "./ContactoComponent.vue?vue&type=script&lang=js&"
export * from "./ContactoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports